export default __webpack_public_path__ + "static/media/Mask Group Error 6@2x.b7166ff1.png";